let epoch_to_date = (epoch) => {
  const d = new Date(0);
  d.setUTCSeconds(epoch);
  // Creating the string yyyy-mm-dd hh:m
  return d.toISOString().split('T')[0] + " " + d.toISOString().split(
    'T')[1].split(':').slice(0, 2).join(":");
};


  // Settings
  const table_config = [{
    Header: 'Date',
    accessor: 'crdate',
    transformer: epoch_to_date
  }, {
    Header: 'Task Title',
    accessor: 'title'
  }, {
    Header: 'Task Type',
    accessor: 'type'
  }, {
    Header: 'Supplier',
    accessor: 'supplier'
  }, {
    Header: 'Company',
    accessor: 'customer'
  }, {
    Header: 'Price',
    accessor: 'price'
  }, {
    Header: 'Cost',
    accessor: 'cost'
  }, {
    Header: 'GM',
    accessor: 'gm'
  }, {
    Header: 'Coordinator',
    accessor: 'coordinator'
  }, {
    Header: 'Retake Reason',
    accessor: 'retakereasonName'
  }, {
    Header: 'Incident Reason',
    accessor: 'errorType'
  }, {
    Header: 'Internal Note',
    accessor: 'internalnote'
  }, {
    Header: 'Found by',
    accessor: 'foundBy'
  }, {
    Header: 'Order id',
    accessor: 'orderid'
  }];


export default table_config;
